import { render, staticRenderFns } from "./Inscritos.vue?vue&type=template&id=893ae88e"
import script from "./Inscritos.vue?vue&type=script&lang=js"
export * from "./Inscritos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports